import React, { useState, useEffect } from "react";
import { Button, Box, TextField } from "@mui/material";
import { useAuth } from "../../../context/AuthContext";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import Alert from "@mui/material/Alert";
import MuiPhoneNumber from "material-ui-phone-number";
import { db, doc, addDoc, collection, deleteDoc } from "../../../firebase";
import { setDoc } from "firebase/firestore";

const Profile = () => {
	const [open, setOpen] = useState(false);
	const [error, setError] = useState("");
	const { getPhone, getFirstname, getLastname, currentUser } = useAuth();

	const [fn, setFn] = useState(null);
	const [ln, setLn] = useState(null);
	const [phone, setPhone] = useState(null);

	useEffect(() => {
		if (getFirstname()?.length > 0) {
			setFn(getFirstname());
		}
		if (getLastname()?.length > 0) {
			setLn(getLastname());
		}
		if (getPhone()?.length > 0) {
			setPhone(getPhone());
		}
	}, [getFirstname, getLastname, getPhone]);

	const changePhoneNumber = (value) => {
		setPhone(value);
	};
	const changeProfile = () => {
		setOpen(true);
	};
	const handleClose = () => {
		setOpen(false);
	};
	const handleSaveChange = async () => {
		console.log("currentUser.uid", currentUser.uid);
		try {
			await setDoc(
				doc(db, "users", currentUser.uid),
				{
					firstname: fn,
					lastname: ln,
					phone: phone,
				},
				(doc) => {
					console.log("success");
					console.log("doc", doc);
				}
			);
			// updateUserInfo();
			setOpen(false);
		} catch (error) {
			console.log(error);
		}
	};
	return (
		<div>
			<Dialog open={open} onClose={handleClose}>
				<DialogTitle>Profile</DialogTitle>
				<DialogContent>
					<DialogContentText>Change your profile information</DialogContentText>

					{/* <AddressForm /> */}
					<Box>{error && <Alert severity="warning">{error}</Alert>}</Box>
					<TextField
						autoFocus
						margin="dense"
						id="firstname"
						label="First name"
						type="email"
						fullWidth
						variant="filled"
						value={fn}
						onChange={(e) => setFn(e.target.value)}
					/>
					<TextField
						margin="dense"
						id="name"
						label="Last name"
						type="text"
						fullWidth
						variant="filled"
						value={ln}
						onChange={(e) => setLn(e.target.value)}
					/>
					<Box sx={{ display: "flex", alignItems: "center" }}>
						<Box sx={{ paddingTop: "20px", pr: 2 }}>Phone:</Box>
						<MuiPhoneNumber
							value={phone}
							regions={"north-america"}
							defaultCountry={"us"}
							onChange={changePhoneNumber}
							style={{ marginTop: "20px", width: "300px" }}
						/>
					</Box>
				</DialogContent>
				<DialogActions sx={{ pb: 3, pr: 3 }}>
					<button
						className="custom_btn_whitebg"
						style={{ width: "100px" }}
						onClick={handleClose}
					>
						Cancel
					</button>
					{/* {addressId && (
						<Button variant="contained" onClick={() => setConfirmDialog(true)}>
							Remove This address
						</Button>
					)} */}
					<button
						className="custom_btn"
						style={{ width: "160px", fontSize: "13px" }}
						onClick={handleSaveChange}
					>
						Save Changes
					</button>
				</DialogActions>
			</Dialog>

			<Box sx={{ mb: 1, mt: 2, display: "flex", width: 1 }}>
				<Box style={{ width: "190px" }}>First Name:</Box>
				<Box>{getFirstname()}</Box>
			</Box>
			<Box sx={{ mb: 1, mt: 1, display: "flex", width: 1 }}>
				<Box style={{ width: "190px" }}>Last Name:</Box>
				<Box>{getLastname()}</Box>
			</Box>
			<Box sx={{ mb: 1, mt: 1, display: "flex", width: 1 }}>
				<Box style={{ width: "190px" }}>Mobile Phone Number:</Box>
				<Box>{getPhone()}</Box>
			</Box>

			<button
				className="custom_btn_whitebg"
				onClick={changeProfile}
				style={{
					paddingLeft: "10px",
					paddingRight: "10px",
					marginTop: "20px",
					marginBottom: "20px",
				}}
			>
				Change your profile information
			</button>
		</div>
	);
};

export default Profile;
